import { useTitle } from "@fyendalscollection/marketing/lib/useTitle";

export const PageLegalDisclaimer = (): JSX.Element => {
	useTitle("Legal Disclaimer");

	return (
		<>
			<h1>Legal Disclaimer</h1>
			<p>
				This website is provided by Fyendal&apos;s Collection in good faith. The
				information and any opinions on this website are based on
				sources that Fyendal&apos;s Collection believes are reliable and accurate.
				Fyendal&apos;s Collection, its directors, officers and employees make no
				representations or warranties of any kind as to the accuracy or
				completeness of the information contained on this website and
				disclaim liability for any loss, damage, cost or expense that
				may arise from any reliance on the information or any opinions,
				conclusions or recommendations contained in it, whether that
				loss or damage is caused by any fault or negligence on the part
				of Fyendal&apos;s Collection, or otherwise, except for any statutory liability
				which cannot be excluded.
			</p>
			<p>
				No part of this Publication may be reproduced without the
				permission of Fyendal&apos;s Collection.
			</p>
			<p>
				The information on this website is subject to change at any
				time. Fyendal&apos;s Collection is under no obligation to update any
				information on this website or correct any errors in the
				information after it is published on the website.
			</p>
			<p>
				The disclaimers and limitations of liability do not prejudice
				your rights under the Consumer Guarantees Act 1993, nor are they
				intended to exclude liability arising under statute.
			</p>
			<p>
				The information published on this website is governed by, and
				has been prepared to comply with, the New Zealand law.
				Fyendal&apos;s Collection does not accept responsibility for the compliance
				of this information with the laws of any other country. The laws
				of New Zealand shall govern your use of the website and by
				visiting this website you hereby agree to submit to the
				exclusive jurisdiction of the New Zealand courts.
			</p>
			<p>
				Although Fyendal&apos;s Collection regularly updates its virus protection
				software, it does not warrant that the server that makes the
				information and contents of this website available is free of
				viruses or bugs. You acknowledge that it is your responsibility
				to implement sufficient procedures and virus checks (including
				anti-virus and other security checks) to satisfy your particular
				requirements for the correct display and/or presentation of any
				material contained on this website.
			</p>
			<p>
				Through this website you may be able to link to other websites
				which are not under the control of Fyendal&apos;s Collection. Fyendal&apos;s Collection has
				no knowledge of or control over the nature, content, and
				availability of those websites. Fyendal&apos;s Collection does not sponsor,
				recommend, or endorse anything contained on these linked
				websites. Fyendal&apos;s Collection does not accept any liability of any
				description for any loss suffered by you by relying on anything
				contained or not contained on these linked websites.
			</p>
			<p>
				Every effort is made to keep the website up and running
				smoothly. However, Fyendal&apos;s Collection takes no responsibility for, and
				will not be liable for, any loss you may suffer due to the
				website being temporarily unavailable either during its planned
				maintenance or due to technical or other issues beyond our
				control.
			</p>
			<p>
				All materials on this website are protected by copyright and
				intellectual property laws and are the property of Fyendal&apos;s Collection
				unless otherwise explicitly stated. The website may also contain
				a number of trademarks, logos, media and symbols which are either owned
				by Fyendal&apos;s Collection or used with the approval of the owner(s).
			</p>
			<p>
				Nothing on the website should be construed as granting any
				licence to use any trademark without the permission of the
				trademark owner. Any material on this website that is identified
				as being subject to copyright of a third party, authorisation to
				use or reproduce such material must be obtained from that third
				party. Unless stated otherwise, you may access and download the
				materials located on this website only for personal,
				non-commercial use.
			</p>
		</>
	);
};
